export default {
    accepted_by: "Кем принято",
    additional_costs: "Расходы",
    additional_discount_correction: "Корректировка по дополнительной скидке",
    additional_income: "Дополнительный доход",
    admin_statistics_future: "Статистика администратора о новых записях на будущие даты",
    administrator_percent: "Процент администратора",
    administrator_sum: "Сумма администратора",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "Все визиты данного филиала, независимо от статуса, включая отмененные",
    apply: "Применить",
    assistant_percent: "Процент ассистента",
    assistant_sum: "Сумма ассистента",
    average_cheque: "Средний чек",
    average_conversion_per_doctor_per_day: "Средний показатель по врачам в день",
    average_conversion_per_doctor_per_period: "Средний показатель по врачам за период",
    average_qty_of_goods_in_cheque: "Среднее кол-во товаров в чеке",
    balance_amount: "Оплачено с депозита",
    balance_return: "Возврат депозита",
    became_permanent: "Стали постоянными",
    by: "Кем",
    by_means: "По форме оплаты",
    by_services: "По услугам",
    calculated_from_calendar_visit_duration: "Считается из длительности записи в календаре",
    came_again: "Пришли повторно",
    came_among_patients: "Из них пришли",
    came_later_over_total_primary: "Процент пришедших повторно от первичных",
    cancel_date: "Дата отмены",
    cancel_reason: "Причина отмены",
    cancelled_among_them: "Из них отменили",
    cancelled_visits: "Отмененные визиты",
    cash_flow_statement: "Отчет о движении ДС",
    cash_received_report_day_explanation: "Полученные денежные средства за период: оплаты за визиты (за исключением таких видов оплат как депозитом, бонусом, гарантией и тд) плюс средства от пополнения / снятия депозита",
    cashdesk_report: "Кассовый отчет",
    conversion: "Конверсия",
    conversion_came_to_permanent: "Конверсия (дошел -> постоянный)",
    cos: "Себестоимость",
    cost_of_attracting_primary_patient: "Стоимость привлечения первичного пациента",
    cost_of_materials: "Стоимость материалов",
    cost_of_visits_for_selected_interval: "Стоимость визитов, прошедших за выбранный интервал",
    costs: "Расходы",
    crm_leads_analytics: "Аналитика заявок CRM",
    curator_id: "Id куратора",
    curator_name: "Имя куратора",
    curator_percent: "Процент куратора",
    curator_sum: "Сумма куратора",
    daily_report: "Отчет за день",
    debt_payments: "Оплата долгов",
    debt_writeoff: "Списание долгов",
    debtor: "Должник",
    debtors: "Должники",
    debtors_statement: "Отчет о должниках",
    deleted_payments_registry: "Реестр удаленных оплат",
    deposit_movements: "Движения депозитов",
    deposit_reconciliation_report: "Акт сверки по депозиту",
    details_by_visits: "Детали по визитам",
    did_not_came_again: "Не пришли повторно",
    did_not_come_among_patients: "Из них не пришли",
    doctor_load_percent: "% загрузки врача",
    doctor_name: "Врач",
    doctor_percent: "Процент врача",
    doctor_salary: "Зарплата врача",
    doctor_statistics: "Статистика по врачам",
    doctor_sum: "Сумма врача",
    doctors_conversion: "Конверсия по врачам",
    doctors_load: "Загрузка врачей",
    duration: "Продолжительность",
    export_from: "Выгрузка от",
    exports: "Выгрузки",
    f057: "Форма 057",
    first_visit_date: "Дата первого визита",
    first_visit_doctor: "Доктор первого визита",
    full_name: "Имя",
    general_percent: "Общий процент",
    have_later_visits_independent_of_interval: "Есть будущие записи независимо от выбранного интервала",
    have_later_visits_within_selected_interval: "Есть дальнейшие записи в выбранном интервале",
    have_no_later_visits_independent_of_interval: "Нет дальнейших записей независимо от выбранного интервала",
    hidden_columns: "Спрятанные колонки",
    hide_cancelled_visits: "Скрывать отмененные визиты",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Оплата за визит за все время, независимо от выбранного интервала отчета",
    in_progress: "В процессе",
    includes_both_discount_on_specific_services_and_general_discount: "Включает скидки на конкретные услуги и общую скидку на визит",
    including_adjustment_for_general_visit_discount: "Включает корректировку по общей скидке на визит",
    including_weighted_average_adjustment_for_general_visit_discount: "Включает средневзвешенную корректировку по общей скидке на визит",
    income_by_doctors: "Выручка по врачам",
    income_by_services: "Выручка по услугам",
    initiator: "Инициатор",
    invoiced: "Выставлено счетов",
    last_visit_date: "Дата последнего визита",
    last_visit_doctor: "Доктор последнего визита",
    last_visit_recommendation: "Рекомендации последнего визита",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "Список пациентов с визитами в данном филиале за выбранный интервал",
    margins: "Валовая прибыль",
    materials_movement_analytics: "Аналитика движения материалов",
    minutes_visit_was_opened_in_control_system: "Минут визит был открыт в системе контроля 'начало и завершение визитов'",
    next_visit_date: "Дата следующего визита",
    next_visit_doctor: "Доктор следующего визита",
    number_of_patient_visits_for_given_interval: "Количество визитов пациента за выбранный интервал",
    only_fiscal_cheques: "Только фискальные чеки",
    only_fiscal_payments: "Только фискальные оплаты",
    only_paid: "Только оплаченные",
    operation_type: "Тип операции",
    orthodontist: "Ортодонт",
    orthopedist: "Ортопед",
    paid_for: "Оплачено за",
    paid_from_account: "Оплачено со счета",
    paid_invoices: "Оплаченные счета",
    paid_sum: "Сумма оплаты",
    patient_deposits: "Депозиты пациентов",
    patient_id: "Id пациента",
    patient_name: "Пациент",
    patient_source: "Источник пациента",
    patient_status: "Статус пациента",
    patients_conversion: "Конверсия пациентов",
    payments_registry: "Реестр оплат",
    payments_within_interval_for_visits_happened_within_interval: "Сумма оплат за выбранный интервал только по визитам, прошедшим в выбранный интервал",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Сумма оплат за выбранный интервал только по визитам, прошедшим в выбранный интервал (без возвратов)",
    pdf_report: "PDF отчет",
    permanent_among_patients: "Из них визиты с постоянными пациентами",
    pl_statement: "Отчет о доходах и расходах",
    plan_treatment_complexes: "Комплексы",
    plan_treatments: "План лечения",
    previous_visit_date: "Дата предыдущего визита",
    price_before_discount: "Сумма до скидки",
    primary: "Первичный",
    primary_among_patients: "Из них визиты с первичными пациентами",
    primary_marketing_expenses: "Первичные расходы на маркетинг",
    primary_records: "Первичные - записано",
    primary_records_came: "Первичные - дошло",
    primary_records_cancelled: "Первичные - отменено",
    primary_records_did_not_come: "Первичные - не дошло",
    primary_records_further: "Первичные - записаны далее",
    primary_records_revenue: "Первичные - выручка",
    product_name: "Название товара",
    recorded_later: "Записаны повторно",
    records: "Записей",
    records_count: "Кол-во визитов",
    refunds_within_interval: "Возвраты за выбранный интервал",
    repeated: "Повторный",
    repeated_records: "Повторные - записано",
    repeated_records_came: "Повторные - дошло",
    repeated_records_cancelled: "Повторные - отменено",
    repeated_records_did_not_come: "Повторные - не дошло",
    repeated_records_further: "Повторные - записаны далее",
    repeated_records_revenue: "Повторные - выручка",
    report_days_limit: "Ограничение периода отчетности (дней)",
    report_is_too_heavy_confirm: "Отчет слишком большой для просмотра на странице, выгрузить отчет в excel файл?",
    revenue: "Выручка",
    revenue_per_hour: "Выручка в час",
    revenues: "Выручка",
    revenues_report_day_explanation: "Оплаты за визиты за выбранный период всеми способами, плюс дополнительный доход (из бухгалтерии) и средства от продажи товаров",
    salary_report: "Отчет по зарплате",
    saldo: "Сальдо",
    sale_date: "Дата продажи",
    sales_funnel_applications: "Воронка: Заявки и обращения",
    sales_funnel_plans: "Воронка: Планы лечений",
    see_all: "Видеть всех",
    see_only_yourself: "Видеть только себя",
    services_amount: "Кол-во услуг",
    show_block_as_free_time: "Учитывать блоки как свободное время",
    show_completed_visits: "Отображать дошедшие визиты",
    show_deleted: "Показывать удаленные",
    show_deleted_doctors: "Показывать удаленных врачей",
    show_only_new_patients: "Отображать только новых пациентов",
    source_of_patient_acquisition: "Изначальный источник привлечения пациента",
    source_of_visit_acquisition: "Источник создания визита",
    source_type: "Тип источника",
    technic_percent: "Процент техника",
    technic_sum: "Сумма техника",
    therapist: "Терапевт",
    total_acquiring_deductions: "Итого вычет по эквайрингу",
    total_cost_of_services: "Итого стоимость услуг",
    total_materials_deductions: "Итого вычет по материалам",
    total_patients: "Кол-во записанных пациентов",
    total_payments: "Итого оплат",
    total_primary: "Итого первичных",
    total_primary_patients_records: "Итого записей первичных пациентов",
    total_revenue: "Итого выручка",
    total_salary: "Итого зарплата",
    total_technic_laboratory_deductions: "Итого вычет по техникам / лаборатории",
    total_unique_primary_patients: "Итого уникальных первичных пациентов",
    total_with_deductions: "Сумма с вычетами",
    unique_patients_recorded_during_selected_report_interval: "Число уникальных пациентов, записанных в выбранном интервале отчета",
    unique_patients_with_first_visit_for_interval: "Уникальных пациентов с первичным визитом в выбранном интервале",
    unpaid_invoices: "Неоплаченные счета",
    updated_date: "Дата изменения",
    visit_id: "Id записи",
    visit_price_including_all_discounts: "Стоимость визита с учетом всех скидок",
    visit_statistics: "Статистика визитов",
    visits_by_source: "Визиты по источникам",
    visits_cost_over_services_count: "Стоимость визитов на количество услуг",
    visits_detailed: "Визиты (расширенный)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Визиты данного филиала, у которых проставлены услуги или статус отличен от 'не пришел'",
    visits_of_current_branch_which_have_services_or_have_status_came: "Визиты, у которых проставлены услуги или статус 'пациент пришел'",
    visits_price_including_all_discounts: "Стоимость визитов с учетом всех скидок",
    where_came_from: "Откуда пришел(-ла)",
    who_cancelled: "Кто отменил",
    who_changed_status: "Кем изменен статус (Оплата / Пришел)",
    who_created: "Кем создано",
    who_updated: "Кем изменено",
    with_patient: "С пациентом",
    worked_days: "Отработанных дней",
    worked_hours: "Отработанных часов",
    your_report_is_processing: "Ваш отчет формируется. Вы получите оповещение, как он будет готов."
}
